import { c as _c } from "react/compiler-runtime";
import { Grid } from "@mui-wrapper";
import { Text } from "@flat-ui";
import { FaroCoreApiUtils } from "@stellar/core-api-client";

/** Content to show when user does not belong to any group or project */
export function MemberProfileEmptyPage(t0) {
  const $ = _c(5);
  const {
    member
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flexDirection: "column",
      backgroundColor: "surfaces.secondary",
      width: "100%",
      justifyContent: "center",
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mb: "30px",
      px: "30px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      color: "text.secondary"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = FaroCoreApiUtils.Member.isTeam(member) ? "Team" : "Member";
  let t5;
  if ($[3] !== t4) {
    t5 = <Grid container={true} sx={t1}><Grid sx={t2}><Text variant="heading16" sx={t3}>{t4} is not connected to any projects or groups</Text></Grid></Grid>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  return t5;
}